import script from "./uploadFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadFiles.vue?vue&type=script&setup=true&lang=js"

import "./uploadFiles.vue?vue&type=style&index=0&id=2391e81e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2391e81e"]])

export default __exports__